import PropTypes from 'prop-types';

const playerType = {
    id: PropTypes.number.isRequired,
    myStudentTimeStop: PropTypes.number.isRequired
};

export { playerType };
